import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d13ba08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" }, null, -1))
const _hoisted_5 = ["innerHTML"]

import { ref, onMounted } from "vue";
import cms from "../services/cms/cms";
import { CmsDocumentTypes, CmsSubscriptionPolicyData } from "../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'subscription-policy',
  setup(__props) {

const policy = ref<CmsSubscriptionPolicyData[]>([]);
const isLoading = ref(true);

const cmsService = cms;

const fetchData = async () => {
  cmsService.getAll(CmsDocumentTypes.CmsSubscriptionPolicy).then((resp: any[]) => {
    policy.value = resp.map((e) => e.data);
    isLoading.value = false;
  });
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-default-back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
            type: "button"
          }, "Back"),
          _createElementVNode("h1", {
            class: "cms-cancellation-policy-title",
            innerHTML: _unref(cms).asText(policy.value[0].title)
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _createElementVNode("div", {
            class: "cms-cancellation-policy",
            innerHTML: _unref(cms).asHtml(policy.value[0].policy)
          }, null, 8, _hoisted_5)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})